/**
 * @file 是否运行在客户端
 * @author zhujialu
 */
define(function (require, exports, module) {
    'use strict'

    return function () {

        return BJY.is.inClient()
    }
})
